async function getStoreInventoryDetails(JSONurl){
  try {
    const response = await fetch(JSONurl);
    return await response.json();
  }
  catch (err) {
    console.log('fetch failed', err);
  }
}

async function checkInstoreProduct(updateVid = null){
  $('#inventory_qty_by_location .loader').removeClass('hide'); // Show loader

  if (updateVid){
    vID = updateVid
  }
  let endpointURL = `https://active-safety.gadget.app/location/inventory?variant_id=${vID}`
  let data = await getStoreInventoryDetails(endpointURL)

  displayStoreData(data);
}

function displayStoreData(res){
  if (!res){ return false; }

  let storeWrapper = $('#stores_wrapper');
  let container = document.getElementById('inventory_qty_by_location');
  let defaultOutOfStockText = container && container.getAttribute('data-default-shipping-message') ? container.getAttribute('data-default-shipping-message') : 'Ships in 3-5 Business Days';
  let nodes = ``;
  let totalVqty = 0;

  for(let i = 0; i < res.data.length; i++){
    let storeName = res.data[i].name.replace('Active Safety ', '')
    let lowercasedStoreName = storeName.replace('Active Safety ', '').replaceAll(' ', '-').toLowerCase(); // eg. newmarket

    let inventory = res.data[i].available
    
    let status = 'In Stock'; // available || unavailable
    let statusText = 'In Stock'
    let statusClass = 'status-In-Stock'

    let listOrder;

    totalVqty += inventory
    
    // Update text and class by inventory
    if (inventory == 0){
      status = 'Out Of Stock';
      statusText = defaultOutOfStockText;
      statusClass = 'status-Out-Of-Stock';
    }else if (inventory <= 1){
      statusText = 'Low Stock';
      statusClass = 'status-Low-Stock';
    }
    
    switch(storeName) {
      case 'Albany':
        listOrder = 1
        break;
      case 'Christchurch': 
        listOrder = 2
        break;
      case 'Distribution Centre': 
        listOrder = 3
        break;
      case 'Pukekohe': 
        listOrder = 4
        break;
      default: break;
    }
  
    nodes += `
    <div class="location location-${lowercasedStoreName}" data-order="${listOrder}">
      <h6 class="location_title">${storeName}</h6>
        <span class="store__availability product-form__inventory ${statusClass}">${statusText}</span>
    </div>
  `
  }

  storeWrapper.empty().html(nodes);
  
  $('#inventory_qty_by_location .loader').addClass('hide'); // Hide loader

  // console.log('totalVqty', totalVqty)
  if (totalVqty == 0){
    $('#inventory_qty_by_location .location').addClass('hide')
    $('#inventory_qty_by_location .message').removeClass('hide')
  }else {
    $('#inventory_qty_by_location .location').removeClass('hide')
    $('#inventory_qty_by_location .message').addClass('hide')
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  let vid = window.location.href.includes('?variant=') ? window.location.search.replace('?variant=','') : null
  checkInstoreProduct(vid)
});
